import { Model } from '@/models/Model';
export class GenerateStudentStatus extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GenerateStudentStatus';
        this.$endpoint = '/commands/lvs-generate-student-subject-statuses';
        this.$fillable = [];
    }
}
